
import React from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { ChevronDown } from 'lucide-react';
import { Lead, LeadStatus, LeadOutcome } from '../types/LeadTypes';
import StatusSelect from '../LeadStatus';
import OutcomeSelect from '../LeadOutcome';
import ValueInput from '../ValueInput';

interface ColumnStyles {
  toggle: string;
  name: string;
  phone: string;
  status: string;
  outcome: string;
  value: string;
  date: string;
}

interface DesktopLeadTableRowProps {
  lead: Lead;
  isOpen: boolean;
  columnStyles: ColumnStyles;
  onToggle: (id: string) => void;
  onOpenNameModal: (id: string) => void;
  onStatusChange: (id: string, status: LeadStatus) => void;
  onOutcomeChange: (id: string, outcome: LeadOutcome | null) => void;
  onValueChange: (id: string, value: string) => void;
}

const DesktopLeadTableRow: React.FC<DesktopLeadTableRowProps> = ({
  lead,
  isOpen,
  columnStyles,
  onToggle,
  onOpenNameModal,
  onStatusChange,
  onOutcomeChange,
  onValueChange
}) => {
  // Estimated revenue - default to $1000
  const estimatedRevenue = "$1000";

  return (
    <TableRow>
      <TableCell className={`${columnStyles.toggle} text-center`}>
        <Button 
          variant="ghost" 
          size="icon" 
          className="h-4 w-4 p-0 mx-auto" 
          onClick={() => onToggle(lead.id)}
        >
          <ChevronDown 
            className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
          />
        </Button>
      </TableCell>
      <TableCell className={columnStyles.name}>
        <Button 
          variant="ghost" 
          className="p-0 h-auto font-medium justify-start hover:bg-transparent hover:underline" 
          onClick={() => onOpenNameModal(lead.id)}
        >
          {lead.name}
        </Button>
      </TableCell>
      <TableCell className={columnStyles.phone}>{lead.phone}</TableCell>
      <TableCell className={columnStyles.status}>
        <StatusSelect 
          status={lead.status} 
          onChange={value => onStatusChange(lead.id, value)} 
          leadType={lead.type}
        />
      </TableCell>
      <TableCell className={columnStyles.outcome}>
        <OutcomeSelect 
          outcome={lead.outcome} 
          onChange={value => onOutcomeChange(lead.id, value)} 
        />
      </TableCell>
      <TableCell className={columnStyles.value}>
        <ValueInput 
          value={lead.value} 
          onChange={value => onValueChange(lead.id, value)}
          outcome={lead.outcome}
          estimatedRevenue={estimatedRevenue}
        />
      </TableCell>
      <TableCell className={columnStyles.date}>{lead.date}</TableCell>
    </TableRow>
  );
};

export default DesktopLeadTableRow;
